var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{attrs:{"value":_vm.calcTopicPercent,"type":_vm._f("audtRatingTyp")(_vm.calcTopicPercent),"show-value":"","format":"percent"}})}
var staticRenderFns = []

export { render, staticRenderFns }